var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/codePreview.scss';
import { useRef } from 'react';
import { SvgIconType } from '../SvgIcon/SvgIconType';
import { useScrollable } from '../Scroll/usePopoverScrollable';
import { TooltipDecorator } from '../Tooltip/TooltipDecorator';
import { IconButton } from '../IconButton/IconButton';
import { IconButtonType } from '../IconButton/IconButtonTypes.interface';
export const CodePreview = (_a) => {
    var { code, copyButtonTooltip, onCopyButtonClick } = _a, restProps = __rest(_a, ["code", "copyButtonTooltip", "onCopyButtonClick"]);
    const ref = useRef(null);
    const codeString = typeof code === 'object' ? JSON.stringify(code, null, 2) : code;
    useScrollable(ref, true, 'xy');
    return (_jsxs("div", Object.assign({ className: "code-preview" }, restProps, { children: [_jsx(TooltipDecorator, { content: copyButtonTooltip, children: _jsx(IconButton, { className: "code-preview-copy", icon: SvgIconType.Copy, mode: IconButtonType.Action, onClick: () => onCopyButtonClick(codeString) }) }), _jsx("div", { ref: ref, className: "code-preview-scroll", children: _jsx("code", { className: "code-preview-code", children: codeString }) })] })));
};
